var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "medical-documents-actions" },
    [
      _c("u-confirm", { ref: "confirm", attrs: { id: "delete-doctype" } }),
      _c("show-files-modal", {
        attrs: {
          files: _vm.record.files.items,
          active: _vm.displayFilesModal,
          path: "upload/analysis",
        },
        on: {
          close: function ($event) {
            _vm.displayFilesModal = false
          },
        },
      }),
      _c(
        "div",
        { staticClass: "medical-documents-buttons" },
        [
          _vm.isUserAbleToControlAnalyses
            ? _c("c-button", {
                staticClass: "medical-documents-resend",
                attrs: { size: "small", label: "Пересдать" },
                on: { click: _vm.resendAnalyse },
              })
            : _vm._e(),
          _c("c-button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: "Комментарий",
                  placement: "top",
                },
                expression:
                  "{\n        container: '#app',\n        trigger: 'hover blur',\n        content: 'Комментарий',\n        placement: 'top',\n      }",
                modifiers: { html: true },
              },
            ],
            staticClass: "medical-documents-actions-comment",
            class: { "set-visible-class": _vm.record.comment },
            attrs: { size: "iconic", icon: "comment" },
            on: {
              click: function ($event) {
                _vm.displayComment = true
              },
            },
          }),
          _c("c-button", {
            staticClass: "documents-actions-menu documents-actions-menu-acti",
            attrs: {
              id: `c-table-actions-menu-${_vm.recordId}`,
              tabindex: "-1",
              size: "iconic",
              icon: "menu",
            },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          staticClass: "medical-documents-actions-comment-modal",
          attrs: {
            id: "medical-documents-actions-comment-modal",
            centered: "",
            "hide-footer": "",
            "hide-header": "",
          },
          model: {
            value: _vm.displayComment,
            callback: function ($$v) {
              _vm.displayComment = $$v
            },
            expression: "displayComment",
          },
        },
        [
          _c("div", [
            _c(
              "span",
              { staticClass: "medical-documents-actions-comment-text" },
              [_vm._v(_vm._s(_vm.record.comment))]
            ),
            _c(
              "svg",
              {
                staticClass: "medical-documents-actions-comment-modal-close",
                attrs: {
                  width: "15",
                  height: "16",
                  viewBox: "0 0 15 16",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
                on: {
                  click: function ($event) {
                    _vm.displayComment = false
                  },
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                    fill: "#8E9CBB",
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                    fill: "#8E9CBB",
                  },
                }),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "b-popover",
        {
          ref: "popover",
          attrs: {
            id: `medical-documents-menu-popover`,
            target: `c-table-actions-menu-${_vm.recordId}`,
            placement: "bottomleft",
            triggers: "click blur",
          },
        },
        [
          _c("div", { staticClass: "documents-actions-menu-popover" }, [
            _vm.record.files.items && _vm.record.files.items.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "documents-actions-menu-popover-item",
                    on: {
                      click: function ($event) {
                        _vm.displayFilesModal = true
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "documents-actions-menu-popover-item-icon",
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "13",
                              height: "15",
                              viewBox: "0 0 13 15",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M11.551 9.4812L8.27747 12.7523C7.478 13.5512 6.39368 14 5.26305 14C4.13242 14 3.04809 13.5512 2.24862 12.7523C1.44914 11.9534 1 10.8699 1 9.74011C1 8.61031 1.44914 7.52679 2.24862 6.72791L7.14835 1.8318C7.68133 1.29921 8.40422 1 9.15797 1C9.91172 1 10.6346 1.29921 11.1676 1.8318C11.7006 2.36439 12 3.08673 12 3.83993C12 4.59312 11.7006 5.31547 11.1676 5.84806L6.26075 10.7442C5.99426 11.0105 5.63282 11.1601 5.25594 11.1601C4.87907 11.1601 4.51763 11.0105 4.25114 10.7442C3.98464 10.4779 3.83493 10.1167 3.83493 9.74011C3.83493 9.36351 3.98464 9.00233 4.25114 8.73604L8.65379 4.34374",
                                stroke: "#8E9CBB",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "documents-actions-menu-popover-item-label",
                      },
                      [_vm._v("Посмотреть файлы")]
                    ),
                  ]
                )
              : _vm._e(),
            _vm.record.files.items && _vm.record.files.items.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "documents-actions-menu-popover-item",
                    on: { click: _vm.downloadAnalyseFiles },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "documents-actions-menu-popover-icon" },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "16",
                              height: "16",
                              viewBox: "0 0 16 16",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M4.70711 6.29289C4.31658 5.90237 3.68342 5.90237 3.29289 6.29289C2.90237 6.68342 2.90237 7.31658 3.29289 7.70711L4.70711 6.29289ZM7 10L6.29289 10.7071C6.68342 11.0976 7.31658 11.0976 7.70711 10.7071L7 10ZM10.7071 7.70711C11.0976 7.31658 11.0976 6.68342 10.7071 6.29289C10.3166 5.90237 9.68342 5.90237 9.29289 6.29289L10.7071 7.70711ZM8 1C8 0.447715 7.55228 0 7 0C6.44772 0 6 0.447715 6 1H8ZM14 10C14 9.44771 13.5523 9 13 9C12.4477 9 12 9.44771 12 10H14ZM2 10C2 9.44771 1.55228 9 1 9C0.447715 9 0 9.44771 0 10H2ZM3.29289 7.70711L6.29289 10.7071L7.70711 9.29289L4.70711 6.29289L3.29289 7.70711ZM7.70711 10.7071L10.7071 7.70711L9.29289 6.29289L6.29289 9.29289L7.70711 10.7071ZM8 10V1H6V10H8ZM12 10V12H14V10H12ZM12 12H2V14H12V12ZM2 12V10H0V12H2ZM2 12H2H0C0 13.1046 0.895431 14 2 14V12ZM12 12V14C13.1046 14 14 13.1046 14 12H12Z",
                                fill: "#8E9CBB",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "documents-actions-menu-popover-item-label",
                      },
                      [_vm._v("Скачать файлы")]
                    ),
                  ]
                )
              : _vm._e(),
            _vm.isUserAbleToControlAnalyses
              ? _c(
                  "div",
                  {
                    staticClass: "documents-actions-menu-popover-item",
                    on: { click: _vm.deleteAnalyse },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "documents-actions-menu-popover-item-icon",
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              "data-v-551a1bd6": "",
                              width: "13",
                              height: "15",
                              viewBox: "0 0 13 15",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "data-v-551a1bd6": "",
                                d: "M1 3C0.447715 3 0 3.44772 0 4C0 4.55228 0.447715 5 1 5V3ZM12 5C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3V5ZM2.92846 3.6C2.92846 4.15228 3.37618 4.6 3.92846 4.6C4.48075 4.6 4.92846 4.15228 4.92846 3.6H2.92846ZM5.21418 1V0V1ZM7.78561 1V0V1ZM8.07132 3.6C8.07132 4.15228 8.51903 4.6 9.07132 4.6C9.6236 4.6 10.0713 4.15228 10.0713 3.6H8.07132ZM6 7C6 6.44772 5.55228 6 5 6C4.44772 6 4 6.44772 4 7H6ZM4 11C4 11.5523 4.44772 12 5 12C5.55228 12 6 11.5523 6 11H4ZM9 7C9 6.44772 8.55228 6 8 6C7.44772 6 7 6.44772 7 7H9ZM7 11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11H7ZM1 5H12V3H1V5ZM4.92846 3.6V2.3H2.92846V3.6H4.92846ZM4.92846 2.3C4.92846 2.21689 4.96122 2.13938 5.01604 2.08395L3.59404 0.677572C3.16663 1.10973 2.92846 1.69355 2.92846 2.3H4.92846ZM5.01604 2.08395C5.0705 2.02889 5.14199 2 5.21418 2V0C4.60438 0 4.02182 0.245036 3.59404 0.677572L5.01604 2.08395ZM5.21418 2H7.78561V0H5.21418V2ZM7.78561 2C7.85779 2 7.92929 2.02889 7.98374 2.08395L9.40575 0.677572C8.97796 0.245036 8.3954 0 7.78561 0V2ZM7.98374 2.08395C8.03856 2.13938 8.07132 2.21689 8.07132 2.3H10.0713C10.0713 1.69355 9.83316 1.10973 9.40575 0.677572L7.98374 2.08395ZM8.07132 2.3V3.6H10.0713V2.3H8.07132ZM4 7V11H6V7H4ZM7 7V11H9V7H7ZM10 4V12H12V4H10ZM9 13H4V15H9V13ZM3 12V4H1V12H3ZM4 13C3.44772 13 3 12.5523 3 12H1C1 13.6569 2.34315 15 4 15V13ZM10 12C10 12.5523 9.55228 13 9 13V15C10.6569 15 12 13.6569 12 12H10Z",
                                fill: "#FF238D",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "documents-actions-menu-popover-item-label",
                      },
                      [_vm._v("Удалить")]
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }